<template>
  <ValidationObserver :key=0 ref="user">
    <form class="ui form form-horizontal" @submit.prevent="validateForm" autocomplete="off">
      <div class="row user-form__sections">
      <div class="col-md-6">
      <div class="box box-info">
        <div class="box-header with-border"><h3 class="box-title">Identity</h3></div>
        <div class="box-body">
          <ValidationProvider name="first_name" v-slot="{errors}" :rules="{ required: true, min: 2 }" slim>
            <div class="form-group" :class="{ 'has-error': errors.length > 0 }">
              <label for="firstName" class="col-sm-2 control-label">First Name</label>
              <div class="col-sm-10 col-md-8">
                <div class="input-group width-100">
                  <input class="form-control width-100" name="first_name" placeholder="First name" type="text" autocomplete="off"
                         v-model="mutableValue.first_name"
                         id="firstName">
                </div>
                <span v-show="errors.length > 0" class="text-danger">{{ errors[0] }}</span>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider name="last_name" v-slot="{errors}" :rules="{ required: true, min: 2 }" slim>
            <div class="form-group" :class="{ 'has-error': errors.length > 0 }">
              <label for="lastName" class="col-sm-2 control-label">Last Name</label>
              <div class="col-sm-10 col-md-8">
                <div class="input-group width-100">
                  <input class="form-control width-100" name="last_name" placeholder="Last Name" type="text" autocomplete="off"
                         v-model="mutableValue.last_name"
                         id="lastName">
                </div>
                <span v-show="errors.length > 0" class="text-danger">{{ errors[0] }}</span>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider name="email" v-slot="{errors}" :rules="{ required: true, email: true }" slim>
            <div class="form-group" :class="{ 'has-error': errors.length > 0 }">
              <label for="email" class="col-sm-2 control-label">Email</label>
              <div class="col-sm-10 col-md-8">
                <div class="input-group width-100">
                  <input class="form-control width-100" name="email" placeholder="Email" type="text" autocomplete="off"
                         v-model="mutableValue.email"
                         id="email">
                </div>
                <span v-show="errors.length > 0" class="text-danger">{{ errors[0] }}</span>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider name="job_role" v-slot="{errors}" slim v-if="showJobRole">
            <div class="form-group" :class="{ 'has-error': errors.length > 0 }">
              <label for="email" class="col-sm-2 control-label">Job Role</label>
              <div class="col-sm-10 col-md-8">
                <div class="input-group width-100">
                  <input class="form-control width-100" name="job_role" placeholder="Job Role" type="text" autocomplete="off"
                         v-model="mutableValue.job_role"
                         id="job_role">
                </div>
                <span v-show="errors.length > 0" class="text-danger">{{ errors[0] }}</span>
              </div>
            </div>
          </ValidationProvider>
        </div>
      </div>
      </div>

      <div class="col-md-6">
      <div class="box box-info">
        <div class="box-header with-border"><h3 class="box-title">Location</h3></div>
        <div class="box-body">
          <ValidationProvider name="country" v-slot="{errors}" slim>
            <div class="form-group" :class="{ 'has-error': errors.length > 0 }">
              <label for="country" class="col-sm-2 control-label">Country</label>
              <div class="col-sm-10 col-md-8">
                <div class="input-group">
                  <select id="country" v-model="mutableValue.country" class="form-control">
                    <option v-for="country in countries" :value="country['id']" :key="country['id']">{{ country['name'] }}</option>
                  </select>
                </div>
                <span v-show="errors.length > 0" class="text-danger">{{ errors[0] }}</span>
              </div>
            </div>
          </ValidationProvider>

          <div class="form-group">
            <label for="region" class="col-sm-2 control-label">Region</label>
            <div class="col-sm-10 col-md-8">
              <select v-if="regions.length > 0" class="form-control" v-model="mutableValue.region">
                <optgroup :label="group['group_name'] != '' ? group['group_name'] : 'Choose a region'"
                          v-for="(group, key) in regions" :key="key">
                  <option v-for="(region, k) in group['values']" :value="region" :key="k">{{ region }}</option>
                </optgroup>
              </select>

              <input v-else type="text" class="form-control" name="region" id="region" @input="mutableValue.region = $event.target.value"
                     autocomplete="off" :value="mutableValue.region" data-vv-as="region">
            </div>
          </div>

          <ValidationProvider name="city" v-slot="{errors}" slim>
            <div class="form-group" :class="{ 'has-error': errors.length > 0 }">
              <label for="city" class="col-sm-2 control-label">City</label>
              <div class="col-sm-10 col-md-8">
                <div class="input-group width-100">
                  <input class="form-control width-100" name="city" placeholder="City" type="text" autocomplete="off"
                         v-model="mutableValue.city"
                         id="city">
                </div>
                <span v-show="errors.length > 0" class="text-danger">{{ errors[0] }}</span>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider name="postcode" v-slot="{errors}" slim>
            <div class="form-group" :class="{ 'has-error': errors.length > 0 }">
              <label for="postcode" class="col-sm-2 control-label">Postcode</label>
              <div class="col-sm-10 col-md-8">
                <div class="input-group width-100">
                  <input class="form-control width-100" name="postcode" placeholder="Postcode" type="text" autocomplete="off"
                         v-model="mutableValue.postcode"
                         id="postcode">
                </div>
                <span v-show="postcodeChanged" class="help-block text-warning">
                  <i class="fa fa-exclamation-triangle"></i>
                  Region and City will be updated from a postcode lookup on save; if it fails, the current values remain.
                </span>
                <span v-show="errors.length > 0" class="text-danger">{{ errors[0] }}</span>
              </div>
            </div>
          </ValidationProvider>
        </div>
      </div>
      </div>

      <div class="col-md-6">
      <div class="box box-info">
        <div class="box-header with-border"><h3 class="box-title">Security</h3></div>
        <div class="box-body">
          <div class="form-group" :class="{ 'has-error': errors.length > 0 }">
            <label for="password" class="col-sm-2 control-label">Change Password</label>
            <div class="col-sm-10 col-md-8">
              <div class="input-group">
                <span class="input-group-addon">
                  <input type="checkbox" v-model="changePassword">
                </span>
                <ValidationProvider name="password" v-slot="{errors}" slim>
                  <!-- type="text" + CSS masking (not type="password") so the browser doesn't
                       recognise a password field and offer to save it. Masking is
                       Chromium/WebKit only; Firefox will show the value in plain text. -->
                  <input class="form-control password-mask" name="password" placeholder="Password" type="text" autocomplete="off"
                         v-model="mutableValue.password" :disabled="!changePassword"
                         id="password">
                  <span v-show="errors.length > 0" class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <ValidationProvider name="app_pin_code" v-slot="{errors}" :rules="{ digits: 4 }" slim>
            <div class="form-group" :class="{ 'has-error': errors.length > 0 }">
              <label for="app_pin_code" class="col-sm-2 control-label">App PIN code</label>
              <div class="col-sm-10 col-md-8">
                <div class="input-group width-100">
                  <input class="form-control width-100" :class="{ 'password-mask': !showPin }" name="app_pin_code" placeholder="App PIN code" type="text" maxlength="4" autocomplete="off"
                         v-model="mutableValue.app_pin_code"
                         id="app_pin_code">
                  <span class="input-group-btn">
                    <button type="button" class="btn btn-default" @click="showPin = !showPin">{{ showPin ? 'Hide' : 'Show' }}</button>
                  </span>
                </div>
                <span class="help-block text-muted">Clear the PIN contents to reset it; the user will be prompted for a new one when they next log in (they must log out first).</span>
                <span v-show="errors.length > 0" class="text-danger">{{ errors[0] }}</span>
              </div>
            </div>
          </ValidationProvider>
        </div>
      </div>
      </div>

      <div class="col-md-12" v-if="mutableValue.permissions">
      <div class="box box-info">
        <div class="box-header with-border" role="button" @click="showPermissions = !showPermissions">
          <h3 class="box-title">
            <i :class="showPermissions ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
            Permissions
          </h3>
        </div>
        <div class="box-body" v-show="showPermissions">
          <p class="permissions__title">Collection</p>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Key</th>
                <th class="text-center">Include drafts</th>
                <th class="text-center">Bypass Paywall</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(collection, i) in collections" :key="i">
                <td>{{collection.key}}</td>
                <td class="text-center"><input type="checkbox" :name="collection.key" data-type="collection" :checked="collection.include_drafts"
                  :data-key="collection.key" data-action="include_drafts" @change="handleChange($event)"></td>
                <td class="text-center"><input type="checkbox" :name="collection.key" data-type="collection" :checked="collection.bypass_paywall"
                  :data-key="collection.key" data-action="bypass_paywall" @change="handleChange($event)"></td>
              </tr>
            </tbody>
          </table>

          <p class="permissions__title">Publisher</p>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Key</th>
                <th class="text-center">Include drafts</th>
                <th class="text-center">Bypass Paywall</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(publisher, i) in publishers" :key="i">
                <td>{{publisher.key}}</td>
                <td class="text-center"><input type="checkbox" :name="publisher.key" data-type="publisher" :checked="publisher.include_drafts"
                  :data-key="publisher.key" data-action="include_drafts" @change="handleChange($event)"></td>
                <td class="text-center"><input type="checkbox" :name="publisher.key" data-type="publisher" :checked="publisher.bypass_paywall"
                  :data-key="publisher.key" data-action="bypass_paywall" @change="handleChange($event)"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      </div>
      </div>

      <div class="form-group">
        <div class="col-sm-12">
          <loading-button>Submit</loading-button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import LoadingButton from '@/components/utils/LoadingButton';
import UserMixin from '@/mixins/UserMixin';
import CountriesMixin from '@/mixins/CountriesMixin';

export default {
  name: 'user-form',
  props: {
    value: {
      type: Object,
    },
    apiErrors: {
      type: Object,
    },
    publishers: {
      type: Object,
    },
    collections: {
      type: Object,
    },
    // Job role only applies to enterprise (teacher) users.
    showJobRole: {
      type: Boolean,
      default: false,
    },
    countries: {
      type: Array,
    },
  },
  mixins: [UserMixin, CountriesMixin],
  components: { LoadingButton, ValidationObserver, ValidationProvider },
  data() {
    return {
      regions: [],
      changePassword: false,
      showPermissions: false,
      showPin: false,
      originalPostcode: null,
    };
  },
  mounted() {
    this.updateRegions(this.mutableValue.country);
    this.originalPostcode = this.mutableValue.postcode;
  },
  methods: {
    // Validate via the ValidationObserver (the ValidationProvider-based fields),
    // not the legacy $validator.validateAll() from FormMixin which doesn't see them.
    async validateForm() {
      const valid = await this.$refs.user.validate();
      if (valid) {
        this.$emit('validated');
      }
    },
    ucfirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    handleChange(e) {
      const key = e.target.getAttribute('data-key');
      const type = e.target.getAttribute('data-type');
      const action = e.target.getAttribute('data-action');
      const { checked } = e.target;
      const currentPermissions = { ...this.value.permissions };
      const i = currentPermissions.books_access.findIndex((value) => (value.key === key && value.type === type));

      if (i >= 0) {
        currentPermissions.books_access[i][action] = checked;
        if (!currentPermissions.books_access[i].include_drafts && !currentPermissions.books_access[i].bypass_paywall) {
          currentPermissions.books_access.splice(i, 1);
        }
      } else {
        const newPermission = {
          key,
          type,
          include_drafts: false,
          bypass_paywall: false,
        };

        newPermission[action] = checked;
        currentPermissions.books_access.push(newPermission);
      }

      this.$set(this.value, 'permissions', currentPermissions);
    },
  },
  watch: {
    'mutableValue.country': function (countryCode) {
      if (!this.hasInitialRegion) {
        this.mutableValue.region = null;
      }
      this.hasInitialRegion = false;
      this.updateRegions(countryCode);
    },
    apiErrors() {
      if (this.apiErrors) {
        this.apiErrors.forEach((item) => {
          this.$validator.errors.add({
            field: item[0],
            msg: item[1][0],
          });
        });
      }
    },
  },
  computed: {
    mutableValue() {
      return Object.assign(this.value);
    },
    // The API re-derives region + city from a postcode lookup when the postcode
    // changes; used to warn the admin their region/city entries may be overwritten.
    postcodeChanged() {
      return (this.mutableValue.postcode || null) !== (this.originalPostcode || null);
    },
  },
};
</script>
<style lang="scss" scoped>
// Direct-child selectors only: lay the section columns out as an equal-height
// wrapping flex grid without disturbing the nested form-horizontal grid columns
// inside each card (the .row-flex utility un-floats those and breaks the layout).
.user-form__sections {
  display: flex;
  flex-wrap: wrap;

  > [class^="col-"] {
    display: flex;

    > .box {
      width: 100%;
    }
  }

  .box-header[role="button"] {
    cursor: pointer;
  }
}

.permissions__title {
  margin-top: 7px;
  font-weight: bold;
}
</style>
